export default __webpack_public_path__ + "static/media/gallery_4_300.4acc9c07.webp";